import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import useAxios from '../../api/axios';
import useAuth from '../../hooks/useAuth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const RESET_URL = 'login?action=renew';
const CHANGE_PWD_URL = '/login.php?action=changePwd';

export const RenewPWD = () => {
  const { auth, isAuthenticated } = useAuth();
  const loggedIn = Boolean(isAuthenticated());

  const [username, setUsername] = useState(auth?.user?.email || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const api = useAxios();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loggedIn) {
      if (!currentPassword || !newPassword || !confirmPassword) {
        toast.error('Täytä kaikki salasanakentät');
        return;
      }

      if (newPassword.length < 8) {
        toast.error('Uuden salasanan tulee olla vähintään 8 merkkiä');
        return;
      }

      if (newPassword !== confirmPassword) {
        toast.error('Uudet salasanat eivät täsmää');
        return;
      }
    }

    try {
      if (loggedIn) {
        const response = await api.post(
          CHANGE_PWD_URL,
          JSON.stringify({ currentPassword, newPassword }),
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        toast.success(response?.data?.message || 'Salasana vaihdettu onnistuneesti.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        navigate('/profiili', { replace: true });
        return;
      }

      await api.post(
        RESET_URL,
        JSON.stringify({ action: 'renew', email: username }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      toast.info('Uusi salasana on lähetetty sähköpostiisi.');
      navigate('/login', { replace: true });
    } catch (err) {
      const message = err?.response?.data?.message || err?.response?.data?.msg;

      if (!err?.response) {
        toast.error('Ei vastausta palvelimelta');
      } else if (err.response?.status === 400) {
        toast.error(message || 'Virheellinen pyyntö');
      } else if (err.response?.status === 401) {
        toast.error(message || 'Nykyinen salasana on virheellinen');
      } else {
        toast.error(message || (loggedIn ? 'Salasanan vaihto epäonnistui' : 'Salasanan palautus epäonnistui'));
      }
    }
  };

  return (
    <div className="max-w-[800px] mt-[96px] w-full h-screen justify-center mx-auto text-center flex flex-col">
      <h1 className="text-4xl mb-4 font-bold text-white">
        {loggedIn ? 'Vaihda salasana' : 'Salasana unohtunut?'}
      </h1>

      {loggedIn ? (
        <>
          <h1 className="text-sm font-bold text-white">Anna nykyinen salasanasi ja aseta uusi vahva salasana.</h1>
          <h1 className="text-sm pb-4 mb-4 font-bold text-white">Muutos tallennetaan suoraan käyttäjätilillesi.</h1>
        </>
      ) : (
        <>
          <h1 className="text-sm font-bold text-white">Anna sähköpostiosoitteesi niin lähetämme uuden salasanasi</h1>
          <h1 className="text-sm pb-4 mb-4 font-bold text-white">siihen mikäli olet rekisteröinyt antamallasi sähköpostilla.</h1>
        </>
      )}

      <form onSubmit={handleSubmit}>
        <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
          {loggedIn ? (
            <>
              <TextField
                variant="filled"
                margin="normal"
                label="Nykyinen salasana"
                type="password"
                value={currentPassword}
                sx={{ width: 5 / 12, backgroundColor: 'white', borderRadius: '8px' }}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <TextField
                variant="filled"
                margin="normal"
                label="Uusi salasana"
                type="password"
                value={newPassword}
                sx={{ width: 5 / 12, backgroundColor: 'white', borderRadius: '8px' }}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextField
                variant="filled"
                margin="normal"
                label="Vahvista uusi salasana"
                type="password"
                value={confirmPassword}
                sx={{ width: 5 / 12, backgroundColor: 'white', borderRadius: '8px' }}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </>
          ) : (
            <TextField
              variant="filled"
              margin="normal"
              label="Sähköposti"
              value={username}
              sx={{ width: 5 / 12, backgroundColor: 'white', borderRadius: '8px' }}
              onChange={(e) => setUsername(e.target.value)}
            />
          )}
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ p: 2 }} spacing={2}>
          <Button type="submit" variant="contained" color="primary">
            {loggedIn ? 'Vaihda salasana' : 'Lähetä'}
          </Button>
          <Button variant="contained" color="secondary" href={loggedIn ? '/profiili' : '/'}>
            Takaisin
          </Button>
        </Stack>
      </form>
    </div>
  );
};
